import * as React from 'react';
export const IcAbdominalPain = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 31 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M7.618 15h10.157c2.095 0 3.81-1.35 3.81-3s-1.715-3-3.81-3H7.618c-.698 0-1.27-.45-1.27-1s.572-1 1.27-1h6.348c1.397 0 2.54-.9 2.54-2V4c0-.55-.572-1-1.27-1-.698 0-1.27.45-1.27 1v1H7.618C5.523 5 3.809 6.35 3.809 8s1.714 3 3.809 3h10.157c.699 0 1.27.45 1.27 1s-.571 1-1.27 1H7.618c-2.095 0-3.809 1.35-3.809 3s1.714 3 3.809 3h8.888v1c0 .55.571 1 1.27 1 .698 0 1.269-.45 1.269-1v-1c0-1.1-1.143-2-2.54-2H7.619c-.698 0-1.27-.45-1.27-1s.572-1 1.27-1zm15.236-5c.33 0 .648-.1.901-.29l1.27-1c.495-.39.495-1.02 0-1.41-.495-.39-1.295-.39-1.79 0l-1.27 1c-.495.39-.495 1.02 0 1.41.254.2.572.29.902.29h-.013zm.901 4.29c-.495-.39-1.295-.39-1.79 0-.495.39-.495 1.02 0 1.41l1.27 1c.254.2.571.29.901.29.33 0 .648-.1.902-.29.495-.39.495-1.02 0-1.41l-1.27-1h-.013zM26.663 11h-1.27c-.698 0-1.27.45-1.27 1s.572 1 1.27 1h1.27c.698 0 1.27-.45 1.27-1s-.572-1-1.27-1z'
      fill='currentColor'
    />
  </svg>
);
